<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>

            <div class="mypage_area personal">
                <ul class="sub_link_list">
                    <li>
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li class="on">
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <ul class="tab_list tab_col_4">
                    <li>
                        <RouterLink to="/HFO_MP_005">회원정보 <br class="pc_none">변경</RouterLink>
                    </li>
                    <!-- <li><RouterLink to="/HFO_MP_006">비밀번호 <br class="pc_none">변경</RouterLink></li> -->
                    <!-- <li v-if="loginInfo.inType == 'USER_IN_NORMAL'">
                        <RouterLink to="/HFO_MP_006">비밀번호 <br class="pc_none">변경</RouterLink>
                    </li> -->
                    <li class="on">
                        <RouterLink to="/HFO_MP_007">마케팅정보 <br class="pc_none">수신동의</RouterLink>
                    </li>
                    <!-- <li><RouterLink to="/HFO_MP_008">회원 탈퇴</RouterLink></li> -->
                </ul>

                <div class="login_box_area">
                    <!-- <h3 class="title_login">
                        Hi-Vitamin<br>Membership
                    </h3> -->

                    <div class="login_input_area">
                        <p class="join_descript">
                            다양한 혜택 등 가장 먼저 받으실 수 있습니다.
                        </p>

                        <div class="term_check_area">
                            <div class="d_check">
                                <input type="checkbox" v-model="marketing.checked" @change="updateMarketingSubOptions"
                                    id="marketing" />
                                <label for="marketing">{{ marketing.text }}</label>
                            </div>

                            <div class="marketing_check_area">
                                <div class="d_check">
                                    <input type="checkbox" v-model="marketing.emailChecked" id="email"
                                        @change="updateMarketingChecked" />
                                    <label for="email">이메일</label>
                                </div>

                                <div class="d_check">
                                    <input type="checkbox" v-model="marketing.smsChecked" id="sms"
                                        @change="updateMarketingChecked" />
                                    <label for="sms">문자</label>
                                </div>

                                <p class="marketing_noti">수신 동의 시 다양한 이벤트 소식을 빠르게 알려드립니다. <br>결제 관련 내용은 동의 여부와 관계없이
                                    발송되오니 참고바랍니다.</p>
                            </div>
                        </div>

                        <div class="btn_login_area">
                            <button class="btn_type2" @click="setMemberInfo">변경</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import { LOCAL_STORAGE_HVM_USERINFO } from '@/lib/Constant';
import { onMounted, reactive } from 'vue';
import { putAxios } from '@/lib/AxiosCall';
import AlertPopup from '@/components/AlertPopup.vue';

export default {
    components: {
        AlertPopup
    },
    data() {
        return {
            alertRequiredShow: false,
        }
    },
    setup() {

        let loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));

        const marketing = reactive({ text: '[선택] 마케팅 정보 수신 동의', checked: false, emailChecked: false, smsChecked: false });

        const updateInitail = () => {
            if (loginInfo.smsYn === 'Y') {
                marketing.smsChecked = true;
            }
            if (loginInfo.emailYn === 'Y') {
                marketing.emailChecked = true;
            }
            if (loginInfo.emailYn === 'Y' || loginInfo.smsYn === 'Y') {
                marketing.checked = true;
            }
        };

        onMounted(() => {
            updateInitail();
        });

        return { loginInfo, marketing, updateInitail };
    },
    methods: {
        // 마케팅 동의 체크박스가 해제되면 이메일 및 문자 동의 체크박스도 해제
        updateMarketingSubOptions() {
            if (!this.marketing.checked) {
                this.marketing.emailChecked = false;
                this.marketing.smsChecked = false;
            }
            else {
                this.marketing.emailChecked = true;
                this.marketing.smsChecked = true;
            }
        },
        // 마케팅 세부 항목(이메일, 문자) 중 하나라도 체크되면 마케팅 동의 체크
        updateMarketingChecked() {
            if (this.marketing.emailChecked || this.marketing.smsChecked) {
                this.marketing.checked = true;
            } else {
                this.marketing.checked = false;
            }
        },
        async setMemberInfo(id) {
            // 이미 AJAX 호출이 되었는지와 localStorage 에 있는지 확인
            let emailChecked = 'N'
            let smsChecked = 'N'
            if (this.marketing.emailChecked == true) {
                emailChecked = 'Y'
            }
            if (this.marketing.smsChecked == true) {
                smsChecked = 'Y'
            }
            const response = await putAxios('bgm/v1/mem/member/' + this.loginInfo.userUuid, {
                emailYn: emailChecked,
                smsYn: smsChecked
            });
            console.log(response);

            this.loginInfo.smsYn = smsChecked;
            this.loginInfo.emailYn = emailChecked;

            localStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(this.loginInfo));

            this.alertContent = '변경이 완료 되었습니다'
            this.alertRequiredShow = true;

        },
    }
}
</script>
<style scoped>
/* MY PAGE 제목과 mypage_area 사이 마진 조정 */
.mypage_area {
    margin-top: 20px !important;
    /* 기존 60px → 20px */
    padding-top: 15px !important;
    /* 기존 32px → 15px */
}

/* PC와 모바일 구분 조정 */
@media (min-width: 1024px) {
    .mypage_area {
        margin-top: 5px !important;
        /* PC에서 25px */
        padding-top: 5px !important;
        /* PC에서 20px */
    }
}

@media (max-width: 1023px) {
    .mypage_area {
        margin-top: 5px !important;
        /* 모바일에서 15px */
        padding-top: 5px !important;
        /* 모바일에서 10px */
    }
}
</style>